export default function encodeContactData(data = {}) {
  return window.btoa(JSON.stringify(data));
}
